import React, { useState, useEffect } from 'react';
import { Card, CardContent, Tab, Grid, Tabs } from '@mui/material';
import QuotesTableWrapper from '../QuotesTableWrapper';
import { StatusNumber } from '../../helper/statusNumber';
import { MixpanelWrapper } from '../MixPanelWrapper';
import TabPanel from '../TabPanel';

/**
 * Component for rendering policy tabs.
 * It allows switching between different views using tabs.
 * @returns {JSX.Element} - The rendered component.
 */
const PoliciesTab = () => {
	const [value, setValue] = useState(0);
	// const [openClientModal, setOpenClientModal] = useState(false);

	useEffect(() => {
		// Track the "Policies Page" event with Mixpanel when the component mounts.
		MixpanelWrapper.track('Policies Page');
	}, []);

	/**
	 * Handle tab change.
	 * @param {React.ChangeEvent<HTMLInputElement> | React.SyntheticEvent<Element, Event>} event - The event object.
	 * @param {number} newValue - The new tab index.
	 */
	const handleChange = (
		event: React.ChangeEvent<HTMLInputElement> | React.SyntheticEvent<Element, Event>,
		newValue: number
	) => {
		setValue(newValue);
	};

	/**
	 * Define accessibility props for a tab.
	 * @param {number} index - The tab index.
	 * @returns {object} - Accessibility props for the tab.
	 */
	const a11yProps = (index: number) => {
		return {
			id: `policy-tab-${index}`,
			'aria-controls': `policy-tabpanel-${index}`,
		};
	};

	return (
		<Card sx={{ borderRadius: '9px', my: '2em' }}>
			<Tabs value={value} onChange={handleChange} sx={{ p: 1 }}>
				<Tab label='Your clients' {...a11yProps(0)} />
			</Tabs>
			<CardContent sx={{ p: 0, pb: '0 !important' }}>
				{/* Display the quotes table */}
				<TabPanel value={value} index={0}>
					<QuotesTableWrapper
						quoteStatuses={[StatusNumber.QuotePolicyCreated]}
						type={'policies'}
					/>
				</TabPanel>
			</CardContent>
		</Card>
	);
};

export default PoliciesTab;
